
import { defineComponent, PropType, ref, watch } from 'vue'
import { Package, usePackageModule } from '@/modules/packages'

export default defineComponent({
    name: 'agreement-form-field-packages',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Array as PropType<string[]>,
            required: true
        }
    },
    setup (props, { emit }) {
        const { packages } = usePackageModule()
        const localModel = ref(props.modelValue ? props.modelValue.map(pid => packages.value.find(p => p.id === pid)) : [])

        watch(() => props.modelValue, (newValue) => {
            localModel.value = newValue ? newValue.map(pid => packages.value.find(p => p.id === pid)) : []
        })

        const onUpdate = (value: Package[]) => {
            emit('update:modelValue', value.map(p => p.id))
        }

        return {
            onUpdate,
            packages,
            localModel
        }
    }
})
